import React from "react";
import { Typography, Tooltip } from "@mui/material";
import InfoIconButton from "./InfoIconButtonComponent";
import MilestoneProgressBar from "./ProgressMilestonesComponent";
import "../../static/project-dashboard-styles.css";
import { formatDateShort } from "../utilityFunctions";

const ProjectMilestonesSection = ({ projectData }) => {
	const procoreWarrantyStartDate = projectData?.project_data?.warranty_start_date || projectData?.warranty_start_date;
    const procoreWarrantyEndDate = projectData?.project_data?.warranty_end_date || projectData?.warranty_end_date;
	
	const hasWarrantyDates = !!(procoreWarrantyStartDate && procoreWarrantyEndDate);

	return (
		<>
			<div className="card-content-header card-content-header-padded">
				<Typography variant="subtitle1" className="card-title">
					Project Milestones
				</Typography>
				<InfoIconButton projectData={projectData} source="percentComplete" />
			</div>
			<div className="milestone-progress-bar-container">
				<MilestoneProgressBar projectData={projectData} />
			</div>
			{/* Warranty Date Area */}
			{hasWarrantyDates && (
				<Tooltip
					title={
						<div className="warning-icon-tooltip-content">
							<Typography className="warranty-tooltip-text">
								Warranty Start and End dates. These are sourced from the Procore Admin panel.
							</Typography>
						</div>
					}
				>
					<div className="warranty-period-row">
						<p className="titillium-web warranty-period-label">Warranty Period: </p>
						<span className="warranty-period-dates">
							<Typography sx={{ textAlign: 'center', fontSize: '.9rem' }} className="titillium-web" variant="body1">
								{formatDateShort(procoreWarrantyStartDate) || '--'}
							</Typography>
							<div className="warranty-period-separator">
								<span> - </span>
							</div>
							<Typography sx={{ textAlign: 'center', fontSize: '.9rem' }} className="titillium-web" variant="body1">
								{formatDateShort(procoreWarrantyEndDate) || '--'}
							</Typography>
						</span>
					</div>
				</Tooltip>
			)}
		</>
	);
};

export default ProjectMilestonesSection;
